export default "/bundles/assets/scroll-up_1b63e9c8cfa5ef36cbf110027941fd4b.png";